export type SerializerParams = Readonly<{
    serializeWithId?: boolean;
}>;
